import {useEffect} from 'react'

import {getUserDeviceDetails} from '@vio/core/src/_web/utils/userAgent'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

export const TrackVercelCanaryRelease = () => {
  const toggle = useToggle()

  useEffect(() => {
    const {userAgentDetails} = getUserDeviceDetails()

    // To avoid any potential issue with firing the toggle for non-allocated audiences
    if (userAgentDetails.isBot) return

    toggle('feature-vercel-canary-users', false, true)
  }, [])

  return null
}
